"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _utils = require("~/utils");
var _process_env_NC_HTTP_BASIC_USER, _process_env_NC_HTTP_BASIC_PASS, _process_env_NC_MAIN_SUBDOMAIN, _process_env_NC_DASHBOARD_URL;
const config = {
    throttler: {
        calc_execution_time: false
    },
    basicAuth: {
        username: (_process_env_NC_HTTP_BASIC_USER = process.env.NC_HTTP_BASIC_USER) != null ? _process_env_NC_HTTP_BASIC_USER : 'defaultusername',
        password: (_process_env_NC_HTTP_BASIC_PASS = process.env.NC_HTTP_BASIC_PASS) != null ? _process_env_NC_HTTP_BASIC_PASS : 'defaultpassword'
    },
    auth: {
        emailPattern: process.env.NC_EMAIL_PATTERN && new RegExp(process.env.NC_EMAIL_PATTERN),
        disableEmailAuth: !!process.env.NC_DISABLE_EMAIL_AUTH
    },
    mainSubDomain: (_process_env_NC_MAIN_SUBDOMAIN = process.env.NC_MAIN_SUBDOMAIN) != null ? _process_env_NC_MAIN_SUBDOMAIN : 'app',
    dashboardPath: (_process_env_NC_DASHBOARD_URL = process.env.NC_DASHBOARD_URL) != null ? _process_env_NC_DASHBOARD_URL : _utils.isEE ? '/' : '/dashboard'
};
const _default = config;
